import { Typography } from "@mui/material";
import { Box } from "@mui/system";
import React from "react";

export default function ChatSearcher({ searcher, setSearcher }) {
  return (
    <Box>
      <Typography marginBottom={"0.5em"} fontWeight={800} variant="h5">
        Chats
      </Typography>
    </Box>
  );
}
